import { render, staticRenderFns } from "./Attractions.vue?vue&type=template&id=1cae32b6&"
import script from "./Attractions.vue?vue&type=script&lang=js&"
export * from "./Attractions.vue?vue&type=script&lang=js&"
import style0 from "./Attractions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports